<template>
  <el-dialog class="detailsDialog" width="1080px" :title="'订单号：'+detailsInfo.order.orderCode" :visible.sync="form.detailsDialog" :append-to-body="true">
    <h1 class="themeBL3">顾客信息</h1>
    <div class="userInfo">
      <div class="userLi">
        <img :src="detailsInfo.order.headImgUrl || 'static/images/head.png'" />
        <h3>姓名：{{ detailsInfo.order.memberName || '--' }}</h3>
        <h4>联系电话：{{ detailsInfo.order.phone || '--' }}</h4>
      </div>
      <div class="userLi">
        <h5>
          会员卡号：
          <span>{{ detailsInfo.order.cardNo || '--' }}</span>
        </h5>
      </div>
    </div>
    <div v-if="detailsInfo.serveItem">
      <div v-if="detailsInfo.serveItem.length > 0">
        <h2 class="themeBL3">服务项目</h2>
        <div class="commonTable">
          <el-table tooltip-effect="light" :data="detailsInfo.serveItem">
            <el-table-column type="index" label="序号">
            </el-table-column>
            <el-table-column prop="itemTypeName" label="项目分类">
            </el-table-column>
            <el-table-column prop="itemName" label="项目服务名称">
            </el-table-column>
            <el-table-column :label="Lib.collectively()">
              <template slot-scope="scope">
                <span>{{ scope.row.technicianName ? scope.row.technicianName : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格（元）">
            </el-table-column>
            <el-table-column prop="time" label="次数">
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope="scope">
                <span>{{ scope.row.discount == 10 || !scope.row.discount ? '--' : scope.row.discount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="resultPrice" label="实收（元）">
            </el-table-column>
          </el-table>
        </div>
        <h1 class="mt_20">
          项目合计：
          <small>￥</small>
          <b>{{ detailsInfo.itemsSumTotal ? detailsInfo.itemsSumTotal.toFixed(2) : '0.00' }}</b>元
        </h1>
      </div>
    </div>
    <div v-if="detailsInfo.packageList">
      <h2 class="themeBL3">服务项目</h2>
      <div class="commonTable">
        <el-table tooltip-effect="light" :data="detailsInfo.packageList">
          <el-table-column type="index" label="序号">
          </el-table-column>
          <el-table-column prop="name" label="套餐名称">
          </el-table-column>
          <el-table-column prop="price" label="价格（元）">
          </el-table-column>
          <el-table-column prop="discount" label="折扣">
            <template slot-scope="scope">
              <span>{{ scope.row.discount == 10 || !scope.row.discount ? '--' : scope.row.discount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="实收（元）">
          </el-table-column>
        </el-table>
      </div>
      <h1 class="mt_20">
        项目合计：
        <small>￥</small>
        <b>{{ detailsInfo.packageList[0].price ? detailsInfo.packageList[0].price.toFixed(2) : '0.00' }}</b>元
      </h1>
    </div>
    <div v-if="detailsInfo.speedProductSale">
      <h2 class="themeBL3">服务项目</h2>
      <div class="commonTable">
        <el-table tooltip-effect="light" :data="detailsInfo.speedProductSale">
          <el-table-column type="index" label="序号">
          </el-table-column>
          <el-table-column prop="name" label="消费产品">
          </el-table-column>
          <el-table-column prop="price" label="价格（元）">
          </el-table-column>
          <el-table-column prop="count" label="数量">
          </el-table-column>
          <el-table-column prop="discount" label="折扣">
            <template slot-scope="scope">
              <span>{{ scope.row.discount == 10 || !scope.row.discount ? '--' : scope.row.discount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="实收（元）">
          </el-table-column>
        </el-table>
      </div>
      <h1 class="mt_20">
        项目合计：
        <small>￥</small>
        <b>{{ detailsInfo.total ? detailsInfo.total.toFixed(2) : '0.00' }}</b>元
      </h1>
    </div>
    <div v-if="detailsInfo.productSale">
      <div v-if="detailsInfo.productSale.length > 0">
        <h2 class="themeBL3">产品销售</h2>
        <div class="commonTable">
          <el-table tooltip-effect="light" :data="detailsInfo.productSale">
            <el-table-column type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column prop="categoryName" label="产品分类">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称">
            </el-table-column>
            <el-table-column prop="price" label="价格（元）">
            </el-table-column>
            <el-table-column prop="count" label="数量">
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope="scope">
                <span>{{ scope.row.discount == 10 || !scope.row.discount ? '--' : scope.row.discount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="金额（元）">
            </el-table-column>
          </el-table>
        </div>
        <h1 class="mt_20">优惠金额：￥{{ detailsInfo.productsSumDiscountTotal ? detailsInfo.productsSumDiscountTotal.toFixed(2) : '0.00' }}元</h1>
        <h1>
          产品合计：
          <small>￥</small>
          <b>{{ detailsInfo.productsSumTotal ? detailsInfo.productsSumTotal.toFixed(2) : '0.00' }}</b>元
        </h1>
      </div>
    </div>
    <div v-if="detailsInfo.serviceFees">
      <div v-if="detailsInfo.serviceFees.length > 0">
        <h2 class="themeBL3">服务赠送</h2>
        <div class="commonTable">
          <el-table tooltip-effect="light" :data="detailsInfo.serviceFees">
            <el-table-column prop="name" label="服务项目名称">
            </el-table-column>
            <el-table-column prop="price" label="项目价值（元）">
            </el-table-column>
            <el-table-column prop="validDateStr" label="有效期限">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <h2 class="themeBL3">备注</h2>
    <h1>备注信息：{{ detailsInfo.order.remark ? detailsInfo.order.remark : '--' }}</h1>
    <h2 class="themeBL3">订单结算</h2>
    <h1>
      <span class="sl">订单总额：￥{{ detailsInfo.order.initaMount ? detailsInfo.order.initaMount.toFixed(2) : '0.00' }}（优惠：-￥{{ detailsInfo.order.discountMoney ? detailsInfo.order.discountMoney.toFixed(2) : '0.00' }}）</span>
      <span class="sm">应付总额：
        <small>￥</small>
        <b>{{ detailsInfo.order.resultaMount ? detailsInfo.order.resultaMount.toFixed(2) : '0.00' }}</b>
      </span>
    </h1>
    <h2 class="themeBL3">付款方式</h2>
    <h1>{{ detailsInfo.order.payType }}</h1>
    <h1>
      <span class="sl">收取现金：
        <small>￥</small>
        <b>{{ detailsInfo.order.payaMount ? detailsInfo.order.payaMount.toFixed(2) : '0.00' }}</b>
      </span>
      <span class="sm">找零：
        <small>￥</small>
        <b>{{ detailsInfo.order.returnaMount ? detailsInfo.order.returnaMount.toFixed(2) : '0.00' }}</b>
      </span>
      <span class="sr">
        <el-button size="small" type="primary" @click="printOrder(1)">打印小票</el-button>
      </span>
    </h1>
  </el-dialog>
</template>

<script>
import { getDetails, hasPrintSet, printOrder } from './api/index';

export default {
  data() {
    return {
      detailsInfo: {
        order: {
          orderCode: ''
        }
      },
      form: {
        memberId: '',
        urlStatus: '',
        detailsDialog: false
      }
    };
  },
  // 监听会员ID的变化
  watch: {
    'form.memberId': function () {
      const vm = this;
      vm.getListData();
    }
  },
  created() {
    const vm = this;
    vm.$emit('tansferPhone', vm.form);
  },
  methods: {
    // 详情列表
    getListData() {
      const vm = this;
      const data = {
        orderId: vm.form.memberId,
      };
      const url = vm.form.urlStatus;
      getDetails(data, url).then((res) => {
        vm.detailsInfo = res.data;
      });
    },
    // 打印订单并返回首页
    printOrder(num) {
      hasPrintSet({}).then((res) => {
        if (res.code == 0) {
          const data = {
            orderId: this.form.memberId,
            mainId: window.sessionStorage.mainId,
            printType: 1, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
            isManual: num ? 1 : 0
          };
          printOrder(data).then((resTwo) => {
            if (resTwo.code == 0) {
              this.$message({
                message: resTwo.msg,
                type: 'success',
                duration: 2000,
                onClose: () => {
                  this.form.detailsDialog = false;
                }
              });
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.detailsDialog {
  position: fixed;
  z-index: 9999;
  overflow: hidden;
  h1 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    .sl {
      width: 33%;
    }
    .sm {
      width: 33%;
      text-align: center;
    }
    .sr {
      width: 34%;
      text-align: right;
    }
    b {
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      padding: 0 5px 0 3px;
    }
  }
  h2 {
    margin: 20px 0;
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
  .userInfo {
    height: 100px;
    box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);
    display: flex;
    .userLi {
      flex: 1;
      padding: 25px 0;
      margin: 0 20px 0 40px;
      img {
        width: 50px;
        height: 50px;
        float: left;
        border-radius: 50%;
      }
      h3 {
        height: 25px;
        line-height: 28px;
        font-size: 15px;
        color: #333;
        font-weight: 600;
        padding-left: 65px;
      }
      h4 {
        height: 25px;
        line-height: 22px;
        font-size: 14px;
        color: #999;
        font-weight: 500;
        padding-left: 65px;
      }
      h5 {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        color: #999;
        font-weight: 500;
        span {
          color: #333;
        }
      }
    }
  }
}
</style>
